import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-dot',
  imports: [],
  templateUrl: './dot.html',
  styleUrl: './dot.scss',
})
export class Dot {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
